var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96145 15.5889H15.5V0.588867H3.96145C2.05765 0.588867 0.5 2.14652 0.5 4.05032V16.7419C0.5 18.6457 2.05765 20.2034 3.96145 20.2034H15.5V17.8961H3.96145C3.32648 17.8961 2.80727 17.3769 2.80727 16.7419C2.80835 16.1081 3.32756 15.5889 3.96145 15.5889Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon);
export default __webpack_public_path__ + "static/media/jobs-icon.7d3d3c505738ad9c61643b7d41ace60d.svg";
export { ForwardRef as ReactComponent };